export default {
  zh: {
    signInWith: '第三方登录'
  },
  en: {
    signInWith: 'Sign in with'
  }
}



// WEBPACK FOOTER //
// ./src/components/loginform/oauthLogin/lang.js